import UMapsWordmark from './components/UMapsWordmark.jsx';
export default function ExamsPage() {
  return (
    <div style={{
      minHeight: "100dvh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "#0d2137",
      padding: "32px 20px",
      fontFamily: "Arial, sans-serif",
      textAlign: "center",
    }}>
      <UMapsWordmark tool="Exams" size={22} style={{
        position: "fixed", top: 14, left: 16, color: "#fff", opacity: 0.92,
      }} />
      <div style={{ fontSize: 44, marginBottom: 20 }}>📝</div>
      <h1 style={{ color: "#fff", fontSize: 22, fontWeight: 800, margin: "0 0 14px", lineHeight: 1.3 }}>
        The exam period for Winter 2026 has ended.
      </h1>
      <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 15, margin: "0 0 28px", maxWidth: 420, lineHeight: 1.6 }}>
        In the meantime, please follow our Instagram for future updates!
      </p>
      <a
        href="https://www.instagram.com/myumaps"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          background: "linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)",
          color: "#fff",
          fontWeight: 800,
          fontSize: 16,
          padding: "14px 28px",
          borderRadius: 12,
          textDecoration: "none",
          boxShadow: "0 4px 20px rgba(0,0,0,0.35)",
        }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
          <circle cx="12" cy="12" r="4"/>
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
        </svg>
        @myumaps
      </a>
      <a href="/" style={{ marginTop: 24, color: "rgba(255,255,255,0.4)", fontSize: 12, textDecoration: "none" }}>
        ← Back to myumaps.ca
      </a>
    </div>
  );
}
